import moment from 'moment';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../../../intl/messages';
import { Route } from './Route';

interface OwnProps {
  pickupAddress: string;
  pickupCity: string;
  pickupDate: Date;
  dropoffAddress: string;
  dropoffCity: string;
  dropoffDate: Date;
  isSaviSelectIntl: boolean;
}

interface CarRouteProps extends OwnProps, InjectedIntlProps {}

const CarRouteBase: FunctionComponent<CarRouteProps> = ({
  intl: { formatMessage, formatTime },
  pickupDate,
  pickupAddress,
  pickupCity,
  dropoffDate,
  dropoffAddress,
  dropoffCity,
  isSaviSelectIntl
}) => {
  const mainTextFormat = !isSaviSelectIntl ? 'ddd D MMM' : 'hh:mm A';
  const subPickUpTime = !isSaviSelectIntl ? formatTime(pickupDate) : moment(pickupDate).format('ddd, D MMM');
  const subDropOffTime = !isSaviSelectIntl ? formatTime(dropoffDate) : moment(dropoffDate).format('ddd, D MMM');

  return (
    <Route
      from={{
        label: formatMessage(messages.car.startLabelText),
        mainText: moment(pickupDate).format(mainTextFormat),
        secondaryText: (
          <>
            {subPickUpTime}
            {formatMessage(messages.car.locationText, {
              address: pickupAddress,
              cityName: pickupCity,
            })}
          </>
        ),
      }}
      to={{
        label: formatMessage(messages.car.endLabelText),
        mainText: moment(dropoffDate).format(mainTextFormat),
        secondaryText: (
          <>
            {subDropOffTime}
            {formatMessage(messages.car.locationText, {
              address: dropoffAddress,
              cityName: dropoffCity,
            })}
          </>
        ),
      }}
      type="Car"
    />
  );
};

const enhance = compose<CarRouteProps, OwnProps>(
  pure,
  injectIntl,
);

export const CarRoute = enhance(CarRouteBase);

CarRoute.displayName = 'CarRoute';
